module.exports = __webpack_public_path__ + "img/06.1f7e7dea.png";